<template>
  <div class="mb-2">
    <button
      @click.prevent.stop="showMenu = !showMenu"
      class="px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-gray-800 hover:bg-gray-500 focus:outline-none focus:border-gray-700 focus:shadow-outline-gray active:bg-gray-700"
    >
      <div class="w-5 h-4 inline-block">
        <svg
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"
          />
        </svg>
      </div>
    </button>
    <div
      :class="{ hidden: !showMenu }"
      class="origin-top-right absolute z-10 w-max right-0 mt-2 rounded-md shadow-lg"
    >
      <div class="inline-block rounded-md bg-white shadow-xs">
        <div class="py-1 relative" v-for="(option, index) in options" :key="index">
          <PriceSummaryCheckbox :model="option"></PriceSummaryCheckbox>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PriceSummaryCheckbox from '@/components/price/PriceSummaryCheckbox';

export default {
  name: 'PriceSummaryMenu',
  components: {
    PriceSummaryCheckbox
  },
  props: {
    options: {
      type: Array
    }
  },
  data() {
    return {
      showMenu: false
    };
  },
  methods: {
    hideMenu() {
      this.showMenu = false;
    }
  },
  created: function() {
    window.addEventListener('click', this.hideMenu);
  },
  destroyed: function() {
    window.removeEventListener('click', this.hideMenu);
  }
};
</script>
